/*
 * @providesModule BalanceBarV3Style
 *
 */
import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import {Dimensions, Platform, StyleSheet} from 'react-native';

const {
  viewPrimaryColor,
  viewSecondaryColor,
  textColorPrimary,
  fontPrimary,
  fontBold,
  textColorSecondary,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  balanceView: {
    ...viewPrimaryColor,
    flex: 1,
    flexDirection: 'row',
    width: Dimensions.get('window').width,
    paddingLeft: Sizes.dynamic({sm: 0, md: 12}),
    paddingRight: 12,
    borderBottomColor: SkillzStyle.convertToOpacity(
      '#000000',
      SkillzStyle.useValueForTheme(0.1, 0.5)
    ),
    borderBottomWidth: 1,
    justifyContent: 'space-between',
  },

  balanceContainer: {
    backgroundColor: 'transparent',
    marginRight: 4,
  },

  currencyContainer: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'flex-start',
    transform: [{scale: Sizes.dynamic({sm: 0.8, md: 0.95, lg: 1})}],
  },

  counterView: {
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },

  countingLabel: {
    textAlign: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },

  countingLabelContainer: {
    flexDirection: 'row',
    alignSelf: 'center',
    flex: 1,
    backgroundColor: 'transparent',
  },

  chatContainer: {
    alignSelf: 'center',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginRight: 10,
    width: 24,
  },

  badge: {
    position: 'absolute',
    top: -2,
    right: -4,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    backgroundColor: 'red',
    height: 8,
    width: 8,
  },

  noNumberBadge: {
    borderRadius: 20,
    backgroundColor: textColorPrimary.color,
    ...Sizes.select({
      phone: {
        height: 4,
        width: 4,
      },
      tablet: {
        height: 5,
        width: 5,
      },
    }),
  },

  chatIcon: {
    ...(Platform.OS === 'ios' ? {marginTop: 2} : {}),
    marginLeft: 5,
    width: 24,
    height: 23,
  },

  backgroundThemingOverride: {
    backgroundColor: SkillzStyle.convertToOpacity('#FFFFFF', 0.2),
  },

  lightThemeOverride: {
    borderColor: SkillzStyle.convertToOpacity('#000000', 0.15),
    borderRadius: 20,
    borderWidth: 1,
    borderStyle: 'solid',
  },

  darkThemeOverride: {
    borderColor: SkillzStyle.convertToOpacity('#FFFFFF', 0.2),
    borderRadius: 20,
    borderWidth: 1,
    borderStyle: 'solid',
  },

  skillzPowered: {
    ...Sizes.select({
      phone: {
        width: 32,
        height: 23,
      },
      tablet: {
        width: 82,
        height: 36,
      },
    }),
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'center',
  },

  tootltipContainer: {
    position: 'absolute',
    left: 8,
  },

  tootltipActionText: {
    fontFamily: SkillzStyle.fullStyles.fontBold.fontFamily,
    color: '#333333',
    fontSize: 12,
    lineHeight: 16,
    marginRight: 2,
  },

  actionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 8,
  },

  tooltipActionButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  tooltipWalletText: {
    ...fontPrimary,
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: -0.5,
    color: '#333333',
    fontWeight: '400',
    ...(Sizes.isBrowser()
          ? {
              flex: 1,
              flexWrap: 'wrap',
            }
          : {}),
  },

  overlayShade: {
    elevation: 14,
    position: 'absolute',
    top: 0,
    height: Dimensions.get('screen').height,
    zIndex: 100,
  },

  overlayContentBlocker: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    flex: 1,
    marginTop: Platform.OS === 'web' ? (Sizes.isPortrait() ? 45 : 52) : 45,
  },

  divider: {
    marginHorizontal: 16,
    height: 1,
    marginBottom: 8,
    backgroundColor: '#919eab70',
  },

  dividerVertical: {
    height: 14,
    width: 1,
    backgroundColor: '#919eab70',
    alignSelf: 'center',
  },

  iconsizeArrow: {
    width: 12,
    height: 12,
  },

  tooltipBox: {
    padding: 16,
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderRadius: 10,
    ...viewSecondaryColor,
  },

  walletTooltipPosition: {
    left: '15%',
    width: 200,
  },

  walletBalanceBreakdownBox: {
    width: 248,
    height: 190,
    overflow: 'hidden',
  },

  walletBalanceComponentPosition: {
    left: '8%',
    width: 250,
  },

  zcashTooltipText: {
    fontSize: 16,
    ...fontBold,
    lineHeight: 28,
    fontWeight: '800',
    color: textColorSecondary.color,
  },

  zcashTooltipIcon: {
    width: 28,
    height: 28,
    marginRight: 4,
  },

  zcashTooltipBox: {
    padding: 16,
    flexDirection: 'row',
  },

  withdrawDisabled: {color: '#7a7a7a'},
});
